/*
  Consentimento de cookies (estilo AdOpt/goadopt.io) — ver o markup em
  wwwroot/index.html (#consent-modal / #consent-botao-flutuante) e o
  estilo em src/sass/modal/_consentimento.scss.

  Regras:
  - Enquanto o usuário não fizer uma escolha explícita (Rejeitar todos,
    Aceitar todos ou, na tela de detalhe, Salvar preferências), nada é
    salvo — a modal volta a abrir sozinha em todo acesso. A tecla ESC
    fecha sem contar como escolha ("fechar sem decidir").
  - A modal sempre abre pela tela de banner (pergunta + instrução + link
    da política + Personalizar/Rejeitar/Aceitar). "Personalizar" abre a
    tela de detalhe (categorias com toggle) dentro da mesma modal; o X
    dessa tela só VOLTA pro banner — não fecha a modal.
  - Ao salvar (Salvar preferências, Rejeitar todos ou Aceitar todos), o
    estado dos toggles é gravado no localStorage e a modal para de abrir
    sozinha. O botão flutuante (ícone de cookie, canto inferior esquerdo)
    reabre a modal a qualquer momento, sempre pelo banner.

  Scripts de terceiros: GTM e Clarity (categoria "desempenho") são
  injetados por este arquivo — ver carregadoresPorCategoria — e NÃO
  ficam mais no <head> de index.html. Pra religar LinkedIn/Meta Pixel
  (comentados no <head>), crie uma função carregaX() aqui e registre na
  categoria "marketing". Se a pessoa desligar uma categoria que já
  estava carregada, a página recarrega ao salvar (não dá pra
  "descarregar" um script já injetado).
  "necessarios" está sempre true, não precisa checar.
*/
(function () {
    var CHAVE_STORAGE = 'salut_cookie_consent';
    var VERSAO = 1;

    var modal = document.getElementById('consent-modal');
    var botaoFlutuante = document.getElementById('consent-botao-flutuante');
    if (!modal || !botaoFlutuante) return;

    var telaBanner = modal.querySelector('[data-consent-tela="banner"]');
    var telaDetalhe = modal.querySelector('[data-consent-tela="detalhe"]');
    var toggles = Array.prototype.slice.call(modal.querySelectorAll('[data-consent-categoria]'));

    function estadoPadrao() {
        var estado = {};
        toggles.forEach(function (input) {
            var categoria = input.getAttribute('data-consent-categoria');
            estado[categoria] = input.disabled || input.defaultChecked; // travadas (necessários) + as que vêm com "checked" no HTML começam ligadas
        });
        return estado;
    }

    function leSalvo() {
        try {
            var registro = JSON.parse(localStorage.getItem(CHAVE_STORAGE));
            if (registro && registro.versao === VERSAO && registro.categorias) return registro;
        } catch (e) { /* localStorage indisponível ou JSON inválido — trata como "nunca escolheu" */ }
        return null;
    }

    function salva(categorias) {
        var registro = { versao: VERSAO, data: new Date().toISOString(), categorias: categorias };
        try { localStorage.setItem(CHAVE_STORAGE, JSON.stringify(registro)); } catch (e) { /* ignora */ }
        return registro;
    }

    function aplicaNosToggles(categorias) {
        toggles.forEach(function (input) {
            if (input.disabled) return; // necessários: sempre marcado, não mexe
            input.checked = !!categorias[input.getAttribute('data-consent-categoria')];
        });
    }

    function leEstadoAtualDosToggles() {
        var estado = {};
        toggles.forEach(function (input) {
            var categoria = input.getAttribute('data-consent-categoria');
            estado[categoria] = input.disabled ? true : input.checked;
        });
        return estado;
    }

    function publicaApi(categorias) {
        window.SalutConsent = {
            categorias: categorias,
            has: function (categoria) { return !!categorias[categoria]; }
        };
    }

    // scripts de terceiros — só são injetados quando a categoria deles está
    // liberada (no carregamento da página ou logo depois de salvar a escolha)
    var GTM_ID = 'GTM-KDHJHWMV';
    var CLARITY_ID = 'yiv1xcd9h3';

    function carregaGtm() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
        document.head.appendChild(script);
    }

    function carregaClarity() {
        window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.clarity.ms/tag/' + CLARITY_ID;
        document.head.appendChild(script);
    }

    var carregadoresPorCategoria = {
        desempenho: [carregaGtm, carregaClarity]
        // marketing: [carregaLinkedin, carregaMetaPixel] — quando tiverem os IDs reais
    };
    var categoriasCarregadas = {};

    function carregaScriptsPermitidos(categorias) {
        Object.keys(carregadoresPorCategoria).forEach(function (categoria) {
            if (!categorias[categoria] || categoriasCarregadas[categoria]) return;
            categoriasCarregadas[categoria] = true;
            carregadoresPorCategoria[categoria].forEach(function (carrega) { carrega(); });
        });
    }

    function mostraTela(nome) {
        telaBanner.hidden = nome !== 'banner';
        telaDetalhe.hidden = nome !== 'detalhe';
        modal.setAttribute('aria-labelledby', nome === 'detalhe' ? 'consent-detalhe-titulo' : 'consent-titulo');
    }

    // precisa bater com a maior duração de transição em
    // src/sass/modal/_consentimento.scss (.consent-caixa)
    var DURACAO_ANIMACAO_MS = 320;

    function abreModal(tela) {
        mostraTela(tela || 'banner');
        modal.hidden = false;
        // força o navegador a "aplicar" o hidden=false antes de ligar a
        // classe que anima a entrada — senão as duas mudanças caem no
        // mesmo frame e não rola transição nenhuma
        modal.getBoundingClientRect();
        modal.classList.add('consent-modal--visivel');
        document.body.classList.add('consent-aberto');
    }

    function fechaModal() {
        modal.classList.remove('consent-modal--visivel');
        document.body.classList.remove('consent-aberto');
        // só esconde de verdade (display:none) depois da transição de saída
        // terminar — antes disso a modal continua no DOM, só some visualmente
        window.setTimeout(function () {
            modal.hidden = true;
        }, DURACAO_ANIMACAO_MS);
    }

    // fecha e GRAVA a escolha — usado só pelas ações explícitas (Salvar
    // preferências, Rejeitar todos, Aceitar todos)
    function fechaModalSalvando() {
        var registro = salva(leEstadoAtualDosToggles());
        // script de terceiro já injetado não tem como ser "descarregado" — se
        // a pessoa desligou uma categoria que já estava rodando, recarrega a
        // página pra ela subir sem esses scripts
        var revogouAlgumaCarregada = Object.keys(categoriasCarregadas).some(function (categoria) {
            return !registro.categorias[categoria];
        });
        if (revogouAlgumaCarregada) {
            window.location.reload();
            return;
        }
        publicaApi(registro.categorias);
        carregaScriptsPermitidos(registro.categorias);
        fechaModal();
    }

    // fecha SEM gravar nada — usado só pelo ESC; a modal volta a abrir
    // sozinha no próximo acesso, já que nada foi salvo
    function fechaModalSemSalvar() {
        fechaModal();
    }

    // estado inicial: aplica o que já foi salvo (ou o padrão) nos toggles;
    // só abre a modal sozinha se ainda não houver nenhuma escolha salva
    var salvoAnteriormente = leSalvo();
    if (salvoAnteriormente) {
        aplicaNosToggles(salvoAnteriormente.categorias);
        publicaApi(salvoAnteriormente.categorias);
        carregaScriptsPermitidos(salvoAnteriormente.categorias);
    } else {
        var padrao = estadoPadrao();
        aplicaNosToggles(padrao);
        publicaApi(padrao);
        carregaScriptsPermitidos(padrao);
        abreModal('banner');
    }

    var btVoltar = modal.querySelector('[data-consent-voltar]');
    var btSalvar = modal.querySelector('[data-consent-salvar]');
    var btPersonalizar = modal.querySelector('[data-consent-personalizar]');
    var btsPermitirTodos = Array.prototype.slice.call(modal.querySelectorAll('[data-consent-permitir-todos]'));
    var btsRejeitarTodos = Array.prototype.slice.call(modal.querySelectorAll('[data-consent-rejeitar-todos]'));

    // X da tela de detalhe: só volta pro banner, não fecha a modal nem salva
    if (btVoltar) btVoltar.addEventListener('click', function () { mostraTela('banner'); });
    if (btSalvar) btSalvar.addEventListener('click', fechaModalSalvando);
    if (btPersonalizar) btPersonalizar.addEventListener('click', function () { mostraTela('detalhe'); });

    btsPermitirTodos.forEach(function (botao) {
        botao.addEventListener('click', function () {
            toggles.forEach(function (input) { if (!input.disabled) input.checked = true; });
            fechaModalSalvando();
        });
    });

    btsRejeitarTodos.forEach(function (botao) {
        botao.addEventListener('click', function () {
            toggles.forEach(function (input) { if (!input.disabled) input.checked = false; });
            fechaModalSalvando();
        });
    });

    // ESC fecha sem salvar, só quando a modal está aberta
    document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape' && !modal.hidden) fechaModalSemSalvar();
    });

    botaoFlutuante.addEventListener('click', function () {
        var atual = leSalvo();
        aplicaNosToggles(atual ? atual.categorias : estadoPadrao());
        abreModal('banner');
    });
})();
